<template lang="pug">
v-app
  toolbar(v-if="$route.name !== 'login'" @snackbar="showSnackbar")
  v-snackbar(v-model="snackbar" :color="snackbarColor" :timeout="3000" :bottom="$vuetify.breakpoint.xs" :top="!$vuetify.breakpoint.xs" right) {{ snackbarMessage }}
  v-content
    router-view
</template>

<script>
import Toolbar from '@/components/Toolbar'

export default {
  name: 'App',
  components: { Toolbar },
  data: () => ({
    snackbar: false,
    snackbarMessage: '',
    snackbarColor: undefined
  }),
  mounted () {
    this.$store.commit('setSnackbarMessage', '')
    this.$store.commit('setSnackbarColor', { color: undefined })
    this.$store.watch(state => state.snackbarMessage, () => {
      const msg = this.$store.state.snackbarMessage
      if (msg !== '') {
        this.snackbar = true
        this.snackbarMessage = this.$store.state.snackbarMessage
        this.snackbarColor = this.$store.state.snackbarColor
        this.$store.commit('setSnackbarMessage', { message: '' })
        this.$store.commit('setSnackbarColor', { color: undefined })
      }
    })
  },
  methods: {
    showSnackbar (message) {
      this.snackbarMessage = message
      this.snackbar = true
    }
  }
};
</script>


<style lang="scss">

</style>
